//用来封装所有的请求nuxt connect ECONNREFUSED 127.0.0.1:80
import axios from './index'
import { useSuccess } from './config'
import { successCode } from './config'

// 添加success方法取代then，在success中不用判断res.code状态
useSuccess(successCode)

export default {
    // 列表
    GetDataList(url, params) {
        return axios.get(url, { params: params });
    },
    // 配置
    GetConfigs(keys) {
        return axios.get(`/home/config`, { params: { keys: keys } });
    },
    /*登录*/
    Login(params) {
        return axios.post(`/login/login`, params)
    },
    /*注册*/
    Register(params) {
        return axios.post(`/login/register`, params)
    },
    /*修改密码*/
    UpdatePassword(params) {
        return axios.post(`/login/pwd`, params)
    },
    UpdateUserInfo(params) {
        return axios.post(`/user/user/edit`, params)
    },
    // 反馈
    GetFeedbackList(params) {
        return axios.get('/system/feedback/index', { params });
    },
    GetFeedbackDetails(id) {
        return axios.get(`/system/feedback/detail`, {params: {id}});
    },
    AddFeedback(params) {
        return axios.post(`/system/feedback/add`, params);
    },
};

